<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" @submit.prevent.native="onSubmit('form')">
    <app-placeholder-horizontal :imageId="form.imageId" @upload="onUpload"/>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item label="Ingredient name" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Category">
          <el-select v-model="form.category" placeholder="Select a category">
            <el-option v-for="category in categories" :key="category.slug" :label="category.title" :value="category.slug"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="Diet">
      <el-checkbox v-model="form.dietGlutenFree">gluten-free</el-checkbox>
      <el-checkbox v-model="form.dietHalal">halal</el-checkbox>
      <el-checkbox v-model="form.dietVegan">vegan</el-checkbox>
      <el-checkbox v-model="form.dietVegetarian">vegetarian</el-checkbox>
    </el-form-item>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item label="Alternate names (separate with comma)">
          <el-input v-model="form.alternateNames"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Substitutes">
          <el-input v-model="form.substitutes"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="Attractive description in 280 characters" prop="desc">
      <el-input type="textarea" v-model="form.desc" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="Content">
      <el-input id="mde" type="textarea" v-model="form.content" :rows="5"></el-input>
    </el-form-item>
    <el-form-item label="Where to buy" prop="purchase">
      <el-input type="textarea" v-model="form.purchase" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="Taste" prop="tastes">
      <el-input v-model="form.tastes"></el-input>
    </el-form-item>
    <el-form-item label="Nutrition">
      <el-input type="textarea" v-model="form.nutrition" :rows="5"></el-input>
    </el-form-item>
    <el-form-item label="How to choose" prop="selection">
      <el-input type="textarea" v-model="form.selection" :rows="5"></el-input>
    </el-form-item>
    <el-form-item label="Storage tips">
      <el-input type="textarea" v-model="form.storage" :rows="5"></el-input>
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
  </el-form>
</template>

<script>
import SimpleMDE from 'simplemde'
import AppPlaceholderHorizontal from '@/components/App/AppPlaceholderHorizontal'

export default {
  components: {
    AppPlaceholderHorizontal,
  },
  props: {
    ingredient: Object,
  },
  data() {
    return {
      loading: false,
      form: {
        alternateNames: this.ingredient.alternate_names.join(', '),
        category: this.ingredient.category,
        content: this.ingredient.content,
        desc: this.ingredient.desc,
        dietGlutenFree: this.ingredient.diet.gluten_free,
        dietHalal: this.ingredient.diet.halal,
        dietVegan: this.ingredient.diet.vegan,
        dietVegetarian: this.ingredient.diet.vegetarian,
        imageId: this.ingredient.image_id,
        nutrition: this.ingredient.nutrition,
        purchase: this.ingredient.purchase,
        selection: this.ingredient.selection,
        storage: this.ingredient.storage,
        substitutes: this.ingredient.substitutes.join(', '),
        tastes: this.ingredient.tastes.join(', '),
        title: this.ingredient.title.toLowerCase(),
      },
      rules: {
        'title': [
          { required: true, message: 'Enter the ingredient name.', trigger: 'blur' },
          { max: 255, message: 'Length should be up to 255.', trigger: 'blur' },
        ],
        'desc': [
          { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
        ],
      },
      categories: [
        { title: 'Dry Herbs', slug: 'dry-herbs' },
        { title: 'Fresh Herbs', slug: 'fresh-herbs' },
        { title: 'Dry Seafood', slug: 'dry-seafood' },
        { title: 'Fresh Seafood', slug: 'fresh-seafood' },
        { title: 'Pickled Ingredients', slug: 'pickled-ingredients' },
        { title: 'Sauces', slug: 'sauces' },
        { title: 'Vegetables', slug: 'vegetables' },
        { title: 'Tofu', slug: 'tofu' }
      ],
    }
  },
  mounted() {
    var mde = new SimpleMDE({ element: document.getElementById('mde') })
    mde.codemirror.on('change', () => {
      this.form.content = mde.value()
    })
  },
  methods: {
    async onSubmit(form) {
      this.loading = true

      this.$refs[form].validate(async valid => {
        if (!valid) {
          this.loading = false
          return false
        }
        try {
          var { data } = await this.$http.put(`/ingredients/${ this.$route.params.id }`, {
            alternate_names: this.form.alternateNames,
            category: this.form.category,
            content: this.form.content || '',
            desc: this.form.desc,
            diet_gluten_free: this.form.dietGlutenFree,
            diet_halal: this.form.dietHalal,
            diet_vegan: this.form.dietVegan,
            diet_vegetarian: this.form.dietVegetarian,
            nutrition: this.form.nutrition,
            purchase: this.form.purchase,
            selection: this.form.selection,
            storage: this.form.storage,
            substitutes: this.form.substitutes,
            tastes: this.form.tastes,
            title: this.form.title,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }
        this.$message.success(data.message)
      })
    },
    async onUpload(imageId) {
      try {
        var { data } = await this.$http.put(`/ingredients/${ this.$route.params.id }/image`, {
          image_id: imageId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }
      this.$message.success(data.message)
    },
  },
}
</script>
